export default __webpack_public_path__ + "static/media/Convit-Z-100-ml-ban.e0eb2ccd.jpg";